export default "/images/framework/CurrentPuzzlechaseRankingCht.a875db5a.svg?a875db5a";